import { ChangeDetectionStrategy, Component, inject, Input, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

enum Language {
	English = 'en',
	German = 'de',
	French = 'fr',
	Spanish = 'es',
	Portugal = 'pt',
	Italy = 'it',
}

@Component({
	selector: 'app-lang-switcher',
	template: ` <ion-row class="ion-justify-content-center lang-block">
		<ion-col class="footer-lang">
			@for (lang of availableLanguages; track lang) {
				<div
					[class.selected]="currentLang() === lang"
					[class.from_menu]="fromMenu"
					(click)="changeLang(lang)"
					expand="block"
				>
					<ion-icon src="../../../assets/flag/custom-flags/{{ lang }}-rect.svg"></ion-icon>
					<p>{{ lang }}</p>
				</div>
			}
		</ion-col>
	</ion-row>`,
	styleUrl: './lang-switcher.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class LangSwitcherComponent {
	@Input() fromMenu = false;

	translate = inject(TranslateService);

	languageEnum = Language;
	availableLanguages = [Language.English, Language.German];
	currentLang = signal(this.translate.currentLang);

	changeLang(language: string) {
		this.translate.setDefaultLang(language);
		this.translate.use(language);
		this.currentLang.set(language);
	}
}
